var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M756 223L756 251",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 756.5,
    cy: 218.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M767.829 215.888L757.354 212.027C757.278 211.991 757.202 211.991 757.126 212.027L746.651 215.888C746.651 215.888 746.651 215.888 746.632 215.888C746.613 215.888 746.613 215.906 746.594 215.906C746.594 215.906 746.575 215.906 746.575 215.923C746.556 215.923 746.556 215.941 746.537 215.941C746.537 215.941 746.537 215.941 746.518 215.959C746.499 215.976 746.499 215.976 746.48 215.994C746.48 216.012 746.461 216.012 746.461 216.03V216.047C746.461 216.065 746.461 216.065 746.442 216.083V216.1C746.442 216.118 746.442 216.136 746.442 216.154V220.741C745.626 220.883 745 221.556 745 222.353C745 223.256 745.797 224 746.765 224C747.733 224 748.53 223.256 748.53 222.353C748.53 221.538 747.903 220.883 747.087 220.741V216.579L749.118 217.323V220.387C749.118 221.272 749.991 222.087 751.604 222.689C753.122 223.238 755.115 223.557 757.24 223.557C759.366 223.557 761.377 223.256 762.876 222.689C764.47 222.105 765.362 221.29 765.362 220.387V217.323L767.81 216.419C767.924 216.384 768 216.277 768 216.154C768 216.03 767.943 215.941 767.829 215.888ZM747.922 222.353C747.922 222.937 747.41 223.415 746.784 223.415C746.158 223.415 745.645 222.937 745.645 222.353C745.645 221.768 746.158 221.29 746.784 221.29C747.41 221.29 747.922 221.768 747.922 222.353ZM764.755 220.404C764.755 221.662 761.738 222.99 757.24 222.99C752.743 222.99 749.725 221.644 749.725 220.404V217.553L757.126 220.28C757.164 220.298 757.202 220.298 757.24 220.298C757.278 220.298 757.316 220.298 757.354 220.28L764.755 217.553V220.404ZM764.945 216.88L757.24 219.714L749.535 216.862L747.6 216.154L757.24 212.593L766.88 216.154L764.945 216.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool1);
export default __webpack_public_path__ + "static/media/school_1.ca481c65af656047b2c26f942c6e7114.svg";
export { ForwardRef as ReactComponent };